import React from "react";

const UnderConstruction = ({ title }) => {
  return (
    <div className="card">
      <div className="card-body text-center py-5">
        <h3 className="mb-2">{title}</h3>
        <p className="text-muted">
          🚧 Page is under construction
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;
